// src/components/Layout.jsx
import React from 'react';
import Header from './Header.jsx';
import Footer from './Footer.jsx';
import OnboardingModal from './onboarding/OnboardingModal.jsx';
import { useAuth } from '../contexts/AuthContext.jsx';
import RefreshStateButton from './RefreshStateButton';

const Layout = ({ children }) => {
  const { showOnboarding, user, loading } = useAuth();
  
  const shouldShowOnboarding = user && showOnboarding && !loading;

  return (
    <>
      {/* Background element separate from content */}
      <div className="app-background"></div>
      
      {/* Content container */}
      <div className="flex flex-col min-h-screen relative z-1">
        <Header />
        
        {/* Main content area */}
        <main className="flex-grow">
          {children}
        </main>
        
        <Footer />
        
        {shouldShowOnboarding && (
          <OnboardingModal 
            isOpen={true} 
            onClose={() => { /* Onboarding modal handles its own close */ }} 
          />
        )}
        
        <RefreshStateButton />
      </div>
    </>
  );
};

export default Layout;